import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FetchDormantStatusReq, GetClientModificationStatusReq, UpdateIncomeRangeReq } from '../models/request.model';
import { environment } from '../../environments/environment';
import { catchError, Observable, retry } from 'rxjs';
import { APICallingLimit } from './constant.service';
import { handleHttpError } from './handle-http-error.service';

@Injectable({
  providedIn: 'root'
})
export class IncomeDetailsService {

  constructor(private http: HttpClient) { }

  FetchDormantStatus(
    fetchDormantStatusReq: FetchDormantStatusReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
      ReqSource: fetchDormantStatusReq.head.AppSource,      
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'FetchDormantStatus',
        fetchDormantStatusReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }


  GetClientModificationStatus(
    getClientModificationStatusReq: GetClientModificationStatusReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'GetClientModificationStatus',
        getClientModificationStatusReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }
  
UpdateIncomeRange(
    updateIncomeRangeReq: UpdateIncomeRangeReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.temp1,
    });
    return this.http
      .post<any>(
       'https://gateway.5paisa.com/BoAPI/Common/UpdateIncomeRange',
       updateIncomeRangeReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  /* 
    @POST('https://gateway.5paisa.com/BoAPI/Common/UpdateIncomeRange')
    async getUpdateIncomeRange(
        @Header('Ocp-Apim-Subscription-Key') AuthType: string,
        @Header('Authorization') authkey: any,
        @Body request: any
    ): Promise<Response> {
        return <Response>{};
    }

  */
}